// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"c0b8703e7d1ef173","888":"3c502d116aea5fa5"}[chunkId] + ".css";
};